/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VolunteerProfileResponse } from '../../models/volunteer-profile-response';

export interface UserControllerFindVolunteerProfile$Params {
  id: string;
}

export function userControllerFindVolunteerProfile(http: HttpClient, rootUrl: string, params: UserControllerFindVolunteerProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<VolunteerProfileResponse>> {
  const rb = new RequestBuilder(rootUrl, userControllerFindVolunteerProfile.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VolunteerProfileResponse>;
    })
  );
}

userControllerFindVolunteerProfile.PATH = '/user/volunteers/{id}';
